import * as React from 'react';
import { AssetId, getSelectedProjectId, getAsset } from 'owa-timestream-store';
import { computed } from 'mobx';
import { dropAssetIntoBucket } from '../actions/publicActions';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { untitledBucket } from './bucketContextualMenuStrings.locstring.json';
import BucketMenuItem from '../components/BucketMenuItem';
import calculateAssetOrder from './calculateAssetOrder';
import getAllBucketsInfo from '../selectors/getAllBucketsInfo';
import loc from 'owa-localize';
import sortChildAssets from './sortChildAssets';

const bucketsContextualMenuItems = computed(() => {
    const onBucketItemClicked = (
        _?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
        item?: IContextualMenuItem
    ) => {
        if (item) {
            const projectId = getSelectedProjectId();
            const bucketId = item.key;
            const bucket = getAsset(projectId, bucketId as AssetId);
            let previousMaxOrder: number | undefined;
            if (bucket.children?.length) {
                const sortedChildren = sortChildAssets(projectId, bucket.children);
                previousMaxOrder = sortedChildren[sortedChildren.length - 1].order;
            }
            dropAssetIntoBucket(
                getSelectedProjectId(),
                item.key as AssetId,
                calculateAssetOrder(previousMaxOrder)
            );
        }
    };

    let numUntitled = 1;
    return getAllBucketsInfo().map(
        info =>
            ({
                key: info.id,
                text: !!info.name ? info.name : loc(untitledBucket, numUntitled++),
                canCheck: false,
                onClick: onBucketItemClicked,
                data: {
                    charmId: info.charmId,
                },
                onRender: renderBucketWithCharm,
            } as IContextualMenuItem)
    );
});

function renderBucketWithCharm(
    item: IContextualMenuItem,
    dismissMenu: () => void
): React.ReactNode {
    return <BucketMenuItem item={item} dismissMenu={dismissMenu} />;
}

export default function getBucketsContextualMenuItems() {
    return bucketsContextualMenuItems.get();
}
